import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import CareTeamTable from "components/user/care-team-table/CareTeamTable";
import UserHeroSection from "components/user/UserHeroSection";
import React from "react";
import UserAuth from "components/AuthGaurd/UserAuth";

const CareTeam = () => {
  return (
    <UserAuth>
      <header>
        <Header />
      </header>
      <UserHeroSection title="Vet Info" btnTitle="Add Vet">
        <div className="tw-w-9/10 tw-mx-auto tw-bg-[#FFFFFF] tw-shadow-3xl tw-rounded-xl  tw-py-7">
          <div className="tw-w-9.5/10 tw-mx-auto tw-text-[#6C6C6C] tw-text-base tw-font-medium">
            <p>
              Add your vet info to opt-in to AutoShare Oncotect’s test results
              with your veterinarians
            </p>
          </div>
        </div>
        <CareTeamTable />
      </UserHeroSection>

      <footer className="tw-flex">
        <Footer />
      </footer>
    </UserAuth>
  );
};

export default CareTeam;
